const initialState = {
    isLoading: true,
    supportrequest:[],
    }
    
    export default initialState;